export default "__VITE_ASSET__4b8b890e__"